export const normalizeComparisonImageLegend = (headers) => {
  const serializedIntervals = headers?.['x-index-range'] ?? headers?.['x-intervals']

  if (!serializedIntervals) {
    return null
  }

  try {
    const intervals = JSON.parse(serializedIntervals)

    if (
      !Array.isArray(intervals) ||
      intervals.length === 0 ||
      !intervals.every(
        (interval) => interval && typeof interval === 'object' && !Array.isArray(interval)
      )
    ) {
      return null
    }

    const totalHa = intervals.reduce((total, interval) => total + Number(interval.ha || 0), 0)
    const normalizedIntervals = intervals.map((interval) => {
      const rawPercentage = Number(interval.percentage)
      const percentage = Number.isFinite(rawPercentage)
        ? rawPercentage > 1
          ? rawPercentage
          : rawPercentage * 100
        : totalHa > 0
        ? (Number(interval.ha || 0) * 100) / totalHa
        : 0

      return {
        ...interval,
        percentage,
      }
    })

    return {
      ...headers,
      'x-index-range': JSON.stringify(normalizedIntervals),
    }
  } catch (error) {
    return null
  }
}

export const getComparisonLegendItem = (role, asset) => {
  if (!asset?.legend || !asset?.legendType) {
    return null
  }

  return {
    isEnhanceable: Boolean(asset.isEnhanceable),
    label: asset.label,
    legend: asset.legend,
    role,
    type: asset.legendType,
  }
}

export const getComparisonLegendItems = (baseAsset, compareAsset) =>
  [
    getComparisonLegendItem('base', baseAsset),
    getComparisonLegendItem('compare', compareAsset),
  ].filter(Boolean)
